module.exports = __webpack_public_path__ + "img/minus.bd3a7a00.svg";